import { languageObject } from "assets/data/languages";
import { SubTopicObject } from "assets/data/topics";
import axios from "axios";
import {
    CountryObject,
    SelectCountryObject
} from "components/files/authForms/SignupForm3";
import FeedLayout from "layouts/files/FeedLayout";
import { useEffect, useRef, useState } from "react";
// import { CountryData } from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
    // DateValue,
    addAllLangs,
    addAllTopics,
    changeAbout,
    changeAvatar,
    changeCountry,
    changeCover,
    changeDOB,
    changeName,
    changePhone,
    changeWebsite
} from "services/redux/settings/account";
import { AppDispatch, RootState } from "services/redux/store";
import {
    Button,
    CustomPhoneInput,
    IconInput,
    Input,
    SVG,
    customToaster
} from "ui";
import { isMobilePhone } from "validator";

import { useOnClickOutside } from "usehooks-ts";
import DatePicker from "react-date-picker";

import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import { Langs, TopicsComponent } from "components";

const AccountInfo = () => {
    const mode = useSelector((state: RootState) => state.site.mode);
    const accountData = useSelector((state: RootState) => state.account);
    const dispatch = useDispatch<AppDispatch>();

    const avatarInputRef = useRef(null);
    const [avatar, setAvatar] = useState(accountData.avatar);
    const handleChangeAvatar = (file: FileList | null) => {
        if (!file) {
            return;
        }
        setAvatar(URL.createObjectURL(file[0]));
    };

    const coverInputRef = useRef(null);
    const [cover, setCover] = useState(accountData.cover);
    const handleChangeCover = (file: FileList | null) => {
        if (!file) {
            return;
        }
        setCover(URL.createObjectURL(file[0]));
    };

    const [name, setName] = useState(accountData.name);
    const [nameError, setNameError] = useState("");
    useEffect(() => {
        if (name.length < 3) {
            setNameError("Name must be more than 2 characters!");
        } else if (nameError.length) {
            setNameError("");
        }
    }, [name]);

    const [about, setAbout] = useState(accountData.about);

    const [langs, setLangs] = useState(accountData.selectedLang);
    const handleRemoveLang = (lang: languageObject) => {
        if (langs.length == 1) {
            // show toast
            customToaster("error", "You must select at least 1 language", mode);
        }
        setLangs(() => langs.filter((l) => l.code != lang.code));
    };
    // toggle lang
    const toggleLang = (lang: languageObject) => {
        if (langs.some((l) => l.code == lang.code)) {
            setLangs(() => langs.filter((l) => l.code != lang.code));
            if (langs.length == 1) {
                // show toast
                customToaster(
                    "error",
                    "You must select at least 1 language",
                    mode
                );
            }
        } else {
            setLangs([...langs, lang]);
        }
    };

    const [topics, setTopics] = useState(accountData.selectedTopics);
    const handleRemoveTopic = (topic: SubTopicObject) => {
        if (topics.length == 1) {
            // show toast
            customToaster("error", "You must select at least 1 topic", mode);
        }
        setTopics(() => topics.filter((t) => t != topic));
    };

    const toggleTopic = (t: SubTopicObject) => {
        if (topics.some((i) => i.SubTopicId == t.SubTopicId)) {
            if (topics.length == 1) {
                // show toast
                customToaster(
                    "error",
                    "You must select at least 1 topic",
                    mode
                );
            }
            const newArr = topics.filter((i) => i.SubTopicId != t.SubTopicId);
            setTopics(newArr);
        } else {
            setTopics([...topics, t]);
        }
    };

    const [phone, setPhone] = useState(accountData.phone);
    const [phoneError, setPhoneError] = useState("");
    const handleChangePhone = (
        e: string
        // contactno: string,
        // dialCode: string,
        // val: CountryData
    ) => {
        setPhone(e);
        if (!isMobilePhone(e)) {
            setPhoneError("You must enter a valid phone number");
        } else {
            setPhoneError("");
        }
    };

    const [website, setWebsite] = useState(accountData.website);

    const [dob, setDob] = useState(accountData.DOB);
    // const [dobError, setDobError] = useState("");

    //  ---------------------------- select country part --------------------------
    const [country, setCountry] = useState(accountData.country);

    // get the countries from countries api
    const [countries, setCountries] = useState<SelectCountryObject[]>([]);
    const getCountries = async () => {
        try {
            const res = await axios.get(
                "https://restcountries.com/v3.1/all?fields=name,flags,cca2,cca3"
            );
            const destructCountries: SelectCountryObject[] = (
                res.data as CountryObject[]
            ).map((count) => ({
                value: count.cca2,
                label: count.name.common,
                flag: count.flags.svg
            }));
            setCountries(destructCountries);
            setFilteredCountries(destructCountries);
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        getCountries();
    }, []);

    /// custom country select
    const countryRef = useRef(null);
    const [dropDownBottom, setDropDownBottomTrue] = useState(true);
    const [countryFilter, setCountryFilter] = useState("");
    const [filteredCountries, setFilteredCountries] = useState<
        SelectCountryObject[]
    >([]);
    useEffect(() => {
        if (countryFilter.length) {
            const newArr = countries.filter(
                (c) =>
                    c.label.toLowerCase().indexOf(countryFilter.toLowerCase()) >
                    -1
            );
            setFilteredCountries(newArr);
        } else {
            setFilteredCountries(countries);
        }
    }, [countryFilter]);

    const [openCountryDropdown, setOpenCountryDropdown] = useState(false);

    const handleToggleCountryDropDown = () => {
        if (openCountryDropdown) {
            setOpenCountryDropdown(false);
            return;
        }
        // @ts-ignore
        const rect = countryRef.current.getBoundingClientRect();
        console.log("rect", rect);

        const parentElBottom = rect.bottom;
        const elHeight = 300;
        // get window height
        const windowHeight = window.innerHeight;
        if (parentElBottom + elHeight >= windowHeight) {
            // make the elemnt above the input
            setDropDownBottomTrue(false);
        } else {
            // make the elemnt above the input
            setDropDownBottomTrue(true);
        }
        setOpenCountryDropdown(true);
    };

    const handleCloseCountryDrop = () => {
        if (!openCountryDropdown) {
            return;
        }
        setCountryFilter("");
        setOpenCountryDropdown(false);
    };
    useOnClickOutside(countryRef, handleCloseCountryDrop);

    //---------------------------------- saving data
    const handleSaveData = () => {
        //validate name
        const errorMsg = "Error saving data!";
        if (name.length < 3) {
            customToaster("error", errorMsg, mode);
            return;
        }
        if (!isMobilePhone(phone)) {
            customToaster("error", errorMsg, mode);
            return;
        }
        if (langs.length >= 1) {
            customToaster("error", errorMsg, mode);
            return;
        }
        if (topics.length >= 1) {
            customToaster("error", errorMsg, mode);
            return;
        }

        // save data in redux
        dispatch(changeName(name));
        dispatch(changeAbout(about));
        dispatch(changeAvatar(avatar));
        dispatch(changeCover(cover));
        dispatch(changeCountry(country));
        dispatch(changePhone(phone));
        dispatch(addAllLangs(langs));
        dispatch(addAllTopics(topics));
        dispatch(changeWebsite(website));
        dispatch(changeDOB(dob));

        customToaster("success", "Account updated succeffully", mode);
    };

    // show different screens

    const [screen, setScreen] = useState<"info" | "langs" | "topics">("info");

    return (
        <FeedLayout pageTitle="Settings">
            <div
                className={`settings-page account-info-page ${screen == "info" ? "" : "is-hidden"}`}
            >
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/settings/account">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Account info</h1>
                    <div></div>
                </div>
                <div className="cover-bg">
                    <img className="cover-image" src={cover} alt="" />
                    <div className="avatar">
                        <img
                            id="user-avatar"
                            className="avatar-image"
                            src={avatar}
                            alt=""
                        />
                        <div
                            className="avatar-button p-relative"
                            onClick={() =>
                                (
                                    avatarInputRef.current as unknown as HTMLInputElement
                                ).click()
                            }
                        >
                            <input
                                type="file"
                                ref={avatarInputRef}
                                className="d-none"
                                onChange={(e) =>
                                    handleChangeAvatar(e.target.files)
                                }
                            />
                            <i className="mdi mdi-camera"></i>
                        </div>
                    </div>
                    <div className="cover-overlay"></div>
                    <div
                        className="cover-edit modal-trigger p-relative"
                        data-modal="change-cover-modal"
                        onClick={() =>
                            (
                                coverInputRef.current as unknown as HTMLInputElement
                            ).click()
                        }
                    >
                        <input
                            type="file"
                            className="d-none"
                            ref={coverInputRef}
                            onChange={(e) => handleChangeCover(e.target.files)}
                        />
                        <i className="mdi mdi-camera"></i>
                        <span className="cursor-pointer">Add cover image</span>
                    </div>
                </div>

                <div className="w-full text-center pt-40 mt-20">
                    <h1 className="white-text fw-700 fs-20em">
                        {accountData.name}
                    </h1>
                    <span className="momeento-p light-grey-text">
                        @{accountData.userName}
                    </span>
                </div>

                <div className="community-info community-info-fields card">
                    {/* name */}
                    <Input
                        label="Full Name"
                        value={name}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setName(e.target.value)}
                        placeHolder="name..."
                    />
                    {/* about */}
                    <Input
                        label="About Me"
                        value={about}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setAbout(e.target.value)}
                        // error={nameError}
                        placeHolder="I'm..."
                    />
                    {/* languages */}
                    <div className="field">
                        <div className="d-flex flex-j-between flex-a-center mb-20">
                            <label>Language</label>
                            <div
                                className="plus-btn cursor-pointer d-flex flex-a-center"
                                onClick={() => setScreen("langs")}
                            >
                                <SVG svg="chevron-right" size={24} />
                            </div>
                        </div>
                        <div className="d-flex flex-j-start flex-a-start flex-wrap gap-10 mb-20">
                            {langs.map((lang) => (
                                <div
                                    key={lang.code}
                                    className="button is-primary is-rounded raised d-flex flex-j-between flex-a-center gap-5"
                                    onClick={() => handleRemoveLang(lang)}
                                >
                                    <span className="lang-name">
                                        {lang.nativeName}
                                    </span>
                                    <span className="remove-lang close-svg momeento-svg"></span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* topics */}
                    <div className="field">
                        <div className="d-flex flex-j-between flex-a-center mb-20">
                            <label>Topics</label>
                            <div
                                className="plus-btn cursor-pointer d-flex flex-a-center"
                                onClick={() => setScreen("topics")}
                            >
                                <SVG svg="chevron-right" size={24} />
                            </div>
                        </div>
                        <div className="d-flex flex-j-start flex-a-start flex-wrap gap-5">
                            {topics.map((topic) => (
                                <div
                                    key={topic.SubTopicId}
                                    className="button is-primary is-rounded raised d-flex flex-j-between flex-a-center gap-10"
                                    onClick={() => handleRemoveTopic(topic)}
                                >
                                    <span className="lang-name">
                                        {topic.Name}
                                    </span>
                                    <span className="remove-lang close-svg momeento-svg"></span>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* phone */}
                    <CustomPhoneInput
                        value={phone}
                        handleChange={handleChangePhone}
                        error={phoneError}
                    />
                    {/* website */}
                    <Input
                        label="Website"
                        value={website}
                        handleChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                        ) => setWebsite(e.target.value)}
                        // error={nameError}
                        placeHolder="Website..."
                    />

                    {/* dob */}
                    <div className="field">
                        <div className="d-flex flex-j-start flex-a-center mb-20">
                            <label>Date of Birth</label>
                        </div>
                        <div className="d-flex flex-j-start flex-a-start flex-wrap gap-10">
                            <DatePicker onChange={setDob} value={dob} />
                        </div>
                    </div>

                    {/* country */}
                    <div className="field">
                        <label>Country</label>
                        <div className="control p-relative country-control">
                            <div
                                className={`country-select-container p-relative ${openCountryDropdown ? "opened" : ""}`}
                                ref={countryRef}
                                onClick={() => console.log("clicked")}
                            >
                                <div className="country-select-input d-flex flex-j-start flex-a-center gap-5 pl-10 pr-10 pt-10 pb-10">
                                    <img
                                        src={country.flag}
                                        className="country-select-img"
                                        alt={country.value}
                                    />
                                    <span className="momeento-p black-text white-text">
                                        {country.label}
                                    </span>
                                    <div
                                        className=" ml-auto"
                                        onClick={() =>
                                            handleToggleCountryDropDown()
                                        }
                                    >
                                        <SVG
                                            svg="chevron-right"
                                            size={18}
                                            className="country-dropdown-svg transition-svg"
                                        />
                                    </div>
                                </div>
                                <div
                                    className={`country-select-dropdown ${dropDownBottom ? "is-bottom" : "is-top"}`}
                                >
                                    <IconInput
                                        value={countryFilter}
                                        handleChange={(
                                            e: React.ChangeEvent<HTMLInputElement>
                                        ) => setCountryFilter(e.target.value)}
                                        rounded
                                    />
                                    <div className="dropdown-container">
                                        {filteredCountries.map((c) => (
                                            <div
                                                className="country-container d-flex flex-j-start flex-a-center gap-5 pl-10 pr-10 pt-10 cursor-pointer"
                                                key={c.value}
                                                onClick={() => {
                                                    setCountry(c);
                                                    handleCloseCountryDrop();
                                                }}
                                            >
                                                <img
                                                    src={c.flag}
                                                    className="country-select-img"
                                                    alt={c.value}
                                                />
                                                <span className="momeento-p black-text white-text">
                                                    {c.label}
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex flex-j-center flex-a-center w-full">
                        <Button
                            text="Save"
                            rounded
                            handleClick={() => handleSaveData()}
                        />
                    </div>
                </div>
            </div>
            {screen == "langs" ? (
                <Langs
                    selectedLanguages={langs}
                    toggleLang={toggleLang}
                    handleHide={() => setScreen("info")}
                />
            ) : (
                ""
            )}
            {screen == "topics" ? (
                <TopicsComponent
                    selectedTopics={topics}
                    toggleTopic={toggleTopic}
                    handleHide={() => setScreen("info")}
                />
            ) : (
                ""
            )}
        </FeedLayout>
    );
};

export default AccountInfo;
